module.exports = __webpack_public_path__ + "ui-static/img/logo-header_light.ffe261af.svg";